import Vuex from 'vuex';
import getters from './getters';
import app from './modules/app';

const store = new Vuex.Store({
    getters,
    modules: {
        app
    },
    state: app.state
})

export default store;